export default __webpack_public_path__ + "static/neckband-382622921e1399f6a3e109061c4df5ad.png";